// @flow
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PowerIcon from '@material-ui/icons/Power';
import { I18n } from 'aws-amplify';
import React from 'react';

type Props = {
    tooltip?: string,
    onClick: Function,
};

export default function ConnectToolbarButton({ tooltip, onClick }: Props) {
    return (
        <Tooltip title={tooltip || I18n.get('Connect')}>
            <IconButton onClick={onClick}>
                <PowerIcon />
            </IconButton>
        </Tooltip>
    );
}
